export const modalConstants = {
    ADD: 'MODAL_ADD',
    EDIT: 'MODAL_EDIT',
    DETAIL: 'MODAL_DETAIL',
    DELETE: 'MODAL_DELETE',
    TOGGLE: 'MODAL_TOGGLE',
};